/*
 * Place (map)
 */

const attachPlace = (node) => {

  const place = {
    scale: 1,
    wasDragged: false,
    isFullscreen: node.classList.contains("fullscreen"),
  };
  node._place = place;

  const rootNode = node;
  const svg = node.querySelector('svg');
  const wrapper = node.querySelector(".a-place-wrapper");
  wrapper.style.touchAction = "none";  // Sur iOS, un double tap zoom la page même avec touchmove bloqué

  const zoomInButton = node.querySelector(".a-place-zoom-in");
  const centerButton = node.querySelector(".a-place-zoom-center");
  const zoomOutButton = node.querySelector(".a-place-zoom-out");

  const naturalWidth = parseInt(rootNode.dataset.width, 10);
  const naturalHeight = parseInt(rootNode.dataset.height, 10);

  const drag = { x: 0, y: 0 };

  let startDrag = { x: 0, y: 0 };
  let startCoords = { x: 0, y: 0 };
  let isDragging = false;
  let svgHeight = naturalHeight;
  let zoom = 1;
  let ctrlPress = false;

  // const viewBox = svg.viewBox.baseVal;
  const viewBox = { x: 0, y: 0, w: naturalWidth, h: svgHeight };

  const svgSize = { w: naturalWidth, h: naturalHeight };

  const getScale = () => {
    const img = svg.querySelector("image");
    const naturalWidth = img.getAttribute('width') || img.getBoundingClientRect().width;
    const displayWidth = img.getBoundingClientRect().width;
    const naturalHeight = img.getAttribute('height') || img.getBoundingClientRect().height;
    const displayHeight = img.getBoundingClientRect().height;

    return {
      scaleX: naturalWidth / displayWidth,
      scaleY: naturalHeight / displayHeight,
    }
  };

  const invokeUpdate = () => {
    // console.log("updateGraphics",rootNode.dataset.updateGraphics )
    if (rootNode.dataset.updateGraphics && rootNode.dataset.updateGraphics in window) {
      window[rootNode.dataset.updateGraphics]();
    }
  };

  const centerZoom = () => {
    const { scaleX, scaleY } = getScale();
    const containerHeight = place.isFullscreen ? window.innerHeight : svg.parentNode.clientHeight;

    const visibleWidth = viewBox.w * zoom;
    const visibleHeight = viewBox.h * zoom;

    const horizontalOverflow = naturalWidth - visibleWidth;
    const verticalOverflow = naturalHeight - visibleHeight;

    // Center horizontally
    drag.x = horizontalOverflow > 0 ? (horizontalOverflow / 2) / scaleX : 0;

    // Center vertically
    if (verticalOverflow > 0) {
      drag.y = (verticalOverflow / 2) / scaleY;
    } else {
      const verticalPadding = (naturalHeight - containerHeight) / 2;
      drag.y = Math.max(0, verticalPadding / scaleY);
    }

    // Clamp drag to bounds
    const maxDragX = Math.max(0, horizontalOverflow / scaleX);
    const maxDragY = Math.max(0, verticalOverflow / scaleY);

    drag.x = Math.max(0, Math.min(maxDragX, drag.x));
    drag.y = Math.max(0, Math.min(maxDragY, drag.y));

    updateViewBox();
    invokeUpdate();
  };


  const getDomCenter = (node) => {

    let point = svg.createSVGPoint();

    const rect = node.getBoundingClientRect();
    point.x = rect.x + rect.width / 2;
    point.y = rect.y + rect.height / 2;

    return point.matrixTransform(svg.getScreenCTM().inverse());
  }

  const zoomBy = (zoomOffset, centerX, centerY) => {

    const newZoom = zoom + zoomOffset;
    if (newZoom >= 2.1 || newZoom < 0.20 ) return; // Empêcher un zoom négatif

    const dw = viewBox.w * zoomOffset;
    const dh = viewBox.h * zoomOffset;
    const dx = dw * centerX / svgSize.w;
    const dy = dh * centerY / svgSize.h;

    // Mise à jour temporaire du zoom
    zoom = newZoom;
    console.log('newZoom', zoom);

    // Calcul des nouvelles dimensions visibles
    const newWidth = viewBox.w * zoom;
    const newHeight = viewBox.h * zoom;

    // Empêcher le débordement
    drag.x = Math.max(0, Math.min(naturalWidth - newWidth, drag.x - dx));
    drag.y = Math.max(0, Math.min(naturalHeight - newHeight, drag.y - dy));

    updateViewBox();
    updateZoom();
    invokeUpdate();
  };


  const zoomTo = (zoomValue, centerX, centerY) => {
    if (zoomValue >= 2.1 || zoomValue < 0.20 ) return; // Empêcher un zoom négatif

    const dw = viewBox.w * zoomValue;
    const dh = viewBox.h * zoomValue;
    const dx = dw / svgSize.w;
    const dy = dh / svgSize.h;

    // Mise à jour temporaire du zoom
    zoom = zoomValue;

    // Calcul des nouvelles dimensions visibles
    const newWidth = viewBox.w * zoom;
    const newHeight = viewBox.h * zoom;

    // Empêcher le débordement
    drag.x = Math.max(0, Math.min(naturalWidth - newWidth, dx));
    drag.y = Math.max(0, Math.min(naturalHeight - newHeight, dy));

    updateViewBox();
    updateZoom();
    invokeUpdate();
  };


  const moveTo = (dx, dy) => {
    const dw = viewBox.w * zoom;
    const dh = viewBox.h * zoom;

    drag.x = Math.max(0, Math.min(naturalWidth - dw, startDrag.x - dx));
    drag.y = Math.max(0, Math.min(naturalHeight - dh, startDrag.y - dy));

    updateViewBox();
    invokeUpdate();
  };

  const moveBy = (dx, dy) => {
    const dw = viewBox.w * zoom;
    const dh = viewBox.h * zoom;

    drag.x = Math.max(0, Math.min(naturalWidth - dw, drag.x + dx));
    drag.y = Math.max(0, Math.min(naturalHeight - dh, drag.y + dy));

    updateViewBox();
    invokeUpdate();
  };

  const updateViewBox = () => {
    const vb = svg.viewBox.baseVal;

    if (zoom <= 1) {
      vb.x = viewBox.x + drag.x;
      vb.y = viewBox.y + drag.y;
    } else {
      const newWidth = zoom * viewBox.w;
      vb.x = viewBox.x + drag.x + ((naturalWidth - newWidth) / 2);
      vb.y = viewBox.y + drag.y;
    }
    vb.width = zoom * viewBox.w;
    vb.height = zoom * viewBox.h;

  };

  const zoomReset = (e) => {
    const { x, y } = getDomCenter(svg);
    zoomTo(1, x, y);
    centerZoom();
    e && e.stopPropagation();
  };

  const zoomIn = (e) => {
    const { x, y } = getDomCenter(svg);
    zoomBy(-0.1, x - drag.x, y - drag.y);
    e && e.stopPropagation();
  };

  const zoomOut = (e) => {
    const { x, y } = getDomCenter(svg);
    zoomBy(0.1, x, y);
    e && e.stopPropagation();
  };

  function toggleFullscreen() {
    if (node.classList.contains("fullscreen")) {
      node.classList.remove("fullscreen");
      place.isFullscreen = false;
    } else {
      node.classList.add("fullscreen");
      place.isFullscreen = true;
    }

    // 🧠 Reset zoom + center after changing size
    setTimeout(() => {
      zoomTo(zoom, 0, 0);
      centerZoom();
      onResize();
      invokeUpdate();
    }, 50);
  }

  const onResize = () => {
    svg.style.transition = "none";

    if (place.isFullscreen) {
      svg.setAttribute("height", window.innerHeight);
      svgHeight = window.innerHeight;
    } else {
      svg.setAttribute("height", svg.parentNode.clientHeight);
      svgHeight = svg.parentNode.clientHeight;
    }

    const rect = wrapper.getBoundingClientRect()
    if (rect.height === 0) {
      setTimeout(onResize, 15);
      return;
    }
    svgHeight = rect.height;

    viewBox.w = naturalWidth;
    viewBox.h = svgHeight;

    updateViewBox();
    centerZoom();
    setTimeout(() => {
      if (svg) {
        svg.style.transition = null;
      }
    }, 300);
    invokeUpdate();
  };

  const onKeyUp = ({ key }) => {
    if (key === "Control" && ctrlPress) {
      ctrlPress = false;
    }
  };

  const onKeyDown = ({ key }) => {
    if (key === "Control" && !ctrlPress) {
      ctrlPress = true;
    } else if (key === "Escape" && place.isFullscreen) {
      toggleFullscreen();
    }
  };

  let placeClicked = null;
  const mouseDownPosition = {x: 0, y: 0};

  const startDragging = (clientX, clientY) => {
    isDragging = true;
    place.wasDragged = true;
    startCoords = { x: clientX, y: clientY };
    startDrag = { x: drag.x, y: drag.y };
    svg.style.transition = "none";
    wrapper.style.cursor = "grabbing";
    if (placeClicked) {
      placeClicked.style.cursor = "grabbing";
    }
  };

  const stopDragging = () => {
    isDragging = false;
    svg.style.transition = ""; // Restore transition property for smooth animations
    wrapper.style.cursor = "grab";

    if (placeClicked) {
      placeClicked.style.cursor = null;
    }
    setTimeout(() => place.wasDragged = false, 200);
  };


  const handleDragMove = (clientX, clientY) => {
    if (!isDragging && placeClicked) {
      const dx = Math.abs(clientX - mouseDownPosition.x);
      const dy = Math.abs(clientY - mouseDownPosition.y);
      if (dx > 5 || dy > 5) {
        startDragging(clientX, clientY);
      }
    }

    if (isDragging) {
      const { scaleX, scaleY } = getScale();
      const dx = (clientX - startCoords.x) * scaleX;
      const dy = (clientY - startCoords.y) * scaleY;
      moveTo(dx, dy);
    }
  };
  const handleMouseMove = (e) => {
    handleDragMove(e.clientX, e.clientY);
  };
  const handleTouchMove = (e) => {
    if (!e.touches || e.touches.length === 0) return;
    const touch = e.touches[0];
    handleDragMove(touch.clientX, touch.clientY);
    e.preventDefault();
  };

  const handlePointerDown = (clientX, clientY, target) => {
    placeClicked = target.closest('.place');
    mouseDownPosition.x = clientX;
    mouseDownPosition.y = clientY;
    if (!placeClicked) {
      startDragging(clientX, clientY);
    }
  };
  
  const onMouseUp = (e) => {
    if (isDragging) {
      stopDragging();
      // zoomImage.style.transition = ""; // Restore transition property for smooth animations
    }
    placeClicked = null;
  };

  // let scale = 1;
  // let isDragging = false;
  // let startCoords = { x: 0, y: 0 };
  // let offset = { x: 0, y: 0 };

  zoomInButton.addEventListener("click", (e) => {
    zoomIn();
    e.stopPropagation();
  });

  centerButton.addEventListener("click", (e) => {
    const { x, y } = getDomCenter(svg);
    zoomTo(1, x, y);
    centerZoom();
    e.stopPropagation();
  });
  
  zoomOutButton.addEventListener("click", (e) => {
    zoomOut();
    e.stopPropagation();
  });

  const updateZoom = () => {
    if(zoom >= 2) {
      zoomOutButton.classList.add("disabled");
    } else {
      zoomOutButton.classList.remove("disabled");
    }
    console.log("zoom", zoom)
    if(zoom <= 0.21) {
      zoomInButton.classList.add("disabled");
    } else {
      zoomInButton.classList.remove("disabled");
    }
    if (zoom === 1) {
      centerButton.classList.add("disabled");
    } else {
      centerButton.classList.remove("disabled");
    }
    rootNode.dataset.zoom = zoom;
  }

  //
  // Export to node
  //
  node.centerZoom = centerZoom;
  node.toggleFullscreen = toggleFullscreen;

  window.addEventListener("resize", onResize);

  const onMounted = () => {
    onResize();
  };

  // On "mounted"
  if (document.readyState === "loading") {
    window.addEventListener("DOMContentLoaded", onMounted);
  } else {
    onMounted();
  }

  document.addEventListener("mousemove", handleMouseMove);
  document.addEventListener("touchmove", handleTouchMove, { passive: false });
  

  // Escape to remove full screen
  document.addEventListener("keydown", onKeyDown);
  document.addEventListener("keyup", onKeyUp);


  document.addEventListener("mouseup", () => setTimeout(onMouseUp, 50)); // This little timeout permit the place.onclick() to check if the click was fired during a dragging (and we do not need to open de place details).
  document.addEventListener("touchend", onMouseUp);

  svg.addEventListener("mousedown", (e) => {
    if (e.button !== 0) return;
    handlePointerDown(e.clientX, e.clientY, e.target);
  });

  svg.addEventListener("touchstart", (e) => {
    if (!e.touches || e.touches.length === 0) return;
    const touch = e.touches[0];
    handlePointerDown(touch.clientX, touch.clientY, e.target);
    e.preventDefault();
  });
  
  
  
  svg.addEventListener("dragstart", (e) => e.preventDefault());

  let lastMouseWheelCall = 0;
  wrapper.onmousewheel = function(e) {
    const now = Date.now();
    if (now - lastMouseWheelCall < 10) return; // Throttle to 10ms intervals to limit trackpad scroll
    lastMouseWheelCall = now;

    // Detect zoom intent more broadly (e.g., trackpad pinch gesture via deltaMode and deltaY magnitude).
    if (ctrlPress || Math.abs(e.deltaY) > 10) {
      e.preventDefault();

      const { x, y } = getDomCenter(svg);
      zoomBy(Math.sign(e.deltaY)*0.05, x, y);
    } else {
      e.preventDefault();

      moveBy(0, Math.sign(e.deltaY)*40);
    }
  }
};




const createPlace = (attributes) => {};

const razorPlace = {
  selector: ".a-place",
  create: createPlace,
  attach: attachPlace,
};

export default razorPlace;
